import { createFileRoute } from "@tanstack/react-router";
import { submissionSearchSchema } from "./-components/submission-search";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { JobSubmissionsTable } from "./-pages/job-submissions-table";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/job-submissions/")({
  validateSearch: submissionSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Job Submissions", link: `/${datasetSlug}/data/job-submissions` }]);
  return <JobSubmissionsTable />;
}
